import styled from 'styled-components';
import { ThemeType } from '../types/Theme';

export const BotoesContainer = styled.div<{theme: ThemeType}>`
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 2rem 2rem 0 2rem;
    .cancelar {
      cursor: pointer;
      color: ${({theme}) => theme.colors.tertiary};
      padding: 1rem;
    }
`;

export const Titulo = styled.div<{theme: ThemeType, textAlign?: 'center' | 'left' | 'right'}>`
  width: 100%;
  font-weight: bold;
  text-align: ${({textAlign}) => textAlign || 'center'};
  color: ${({theme}) => theme.colors.secondary};
`;

export const Subtitulo = styled.div<{theme: ThemeType}>`
  width: 100%;
  text-align: center;
  color: ${({theme}) => theme.colors.tertiary};
  font-size: 16px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
